<template>
  <SFeaturesSelection
    :vehicleCategoryId="getVehicleCategoryId"
    :selectedFeatures="getSelectedFeatures"
    :animalsTransportation="getAnimalsTransportation"
    :rideType="getRideType"
    :currentLang="getCurrentLang"
    :appConfig="getAppConfig"
    :passengersAmount="getPassengersAmount"
    @setFeatureAmount="setFeatureAmount"
    @setAnimalsTransportation="setAnimalsTransportation"
  />
</template>
<script lang="ts">
export default {
  name: 'FeaturesSelection',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import appConfig from '@/appConfig';
import { SFeaturesSelection } from '@slg/web-customer-shared';
import { useStore, useRouteRef } from '@/composables';

defineProps({
  isValidAmountOfPassenger: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['clearBookingRequestError']);
const store = useStore();
const route = useRouteRef();

const getAdults = computed(() => store.getters['booking/getAdults']);
const getChildren = computed(() => store.getters['booking/getChildren']);
const getAnimalsTransportation = computed(() => store.getters['booking/getAnimalsTransportation']);
const getRideType = computed(() => store.getters['booking/getRideType']);
const getVehicleCategoryId = computed(() => store.getters['booking/getVehicleCategoryId']);
const getSelectedFeatures = computed(() => store.getters['booking/getSelectedFeatures']);
const getAppConfig = computed(() => appConfig);
const getCurrentLang = computed(() => route.value.params.lang);
const getPassengersAmount = computed(() => getAdults.value + getChildren.value);

function setFeatureAmount(feature: unknown) {
  store.commit('booking/setFeatureAmount', feature);
  emit('clearBookingRequestError');
}

function setAnimalsTransportation(animalsTransportation: boolean) {
  store.commit('booking/setAnimalsTransportation', animalsTransportation);
  emit('clearBookingRequestError');
}
</script>
<style lang="scss" scoped>
</style>
